import { render, staticRenderFns } from "./DispatcherOrderRequestReviewList.vue?vue&type=template&id=88e8a6fe&"
import script from "./DispatcherOrderRequestReviewList.vue?vue&type=script&lang=js&"
export * from "./DispatcherOrderRequestReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports